import { DataVizPalette, DonutChart, getColorFromToken } from "@fluentui/react-charting";
import { Legend, Legends } from "@fluentui/react-charts-preview";
import { IStandardChartData } from "models/IChartData";

export const CustomDonutChart = ({ chartData }: { chartData: IStandardChartData }) => {
    const { series, title } = chartData;

    const donutChartData = series.map((s, index) => ({
        legend: s.name,
        data: s.y[0] || 0,
        xAxisCalloutData: s.name,
        color: getColorFromToken(DataVizPalette[`color${(index % 10) + 1}` as keyof typeof DataVizPalette]),
    }));

    const data = {
        chartTitle: title,
        chartData: donutChartData,
    };

    const legends: Legend[] = donutChartData.map((item, index) => ({
        title: item.legend,
        color: item.color,
        action: () => console.log(`${item.legend} clicked`),
        hoverAction: () => console.log(`Hover action for ${item.legend}`),
        onMouseOutAction: () => undefined,
    }));

    return (
        <div style={{ maxWidth: "600px", textAlign: "center" }}>
            <DonutChart
                culture={typeof window !== "undefined" ? window.navigator.language : "en-us"}
                data={data}
                innerRadius={55}
                href={"https://developer.microsoft.com/en-us/"}
                legendsOverflowText={"See More"}
                hideLegend={true}
                height={220}
            />

            <div style={{ maxHeight: "150px", overflowY: "auto", marginTop: "10px" }}>
                <Legends
                    legends={legends}
                    allowFocusOnLegends={true}
                    canSelectMultipleLegends={false}
                    overflowText={"See More Legends"}
                />
            </div>
        </div>
    );
};